import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DataService } from '@services/core-services/data.service';
import { AppSettings } from '@services/core-services/app.settings';
import { LoyaltyPointActivity } from './models/loyaltiy-activity';
import { PaginatedList } from '@services/core-services/models/paginated-list';
import { Query } from '@services/core-services/models';
import { CustomerId } from '@services/customer-services/models/customer-id';
import { LoyaltyPointActivityListResponse } from './models/loyaltiy-activity.response';
import { LoyaltyPrograms } from './models/loyaltiy-programs';
import { LoyaltyProgramListResponse } from './models/loyaltiy-program.response';
import { AddLoyaltyPointActivity } from './models/add-loyalty-request';
import { LoyaltyId } from './models/loyalty-id';
import { LoyaltyProgramDetailResponse } from './models/loyaltiy-program-detail.response';
import { CachingApiService } from '@services/core-services/api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyService {
  customerUrl = 'customers';
  private readonly apiEndPoint = `${this.appSettings.app_config.base_url}club-points`;
  private readonly apiEndPointAddLoyalty = `${this.appSettings.app_config.base_url}club-points`;

  constructor(
    private dataService: DataService,
    private appSettings: AppSettings,
    private readonly cacheApi: CachingApiService
  ) {}

  getLoyaltyData(
    filterSearch: any = { searchData: '', filter_by: '' },
    pageNumber: number = 1,
    itemsPerPage: number = 25,
    selectedTab = {},
    sortList = {}
  ) {
    return this.dataService.get(this.apiEndPoint, {
      search: filterSearch.searchData || '',
      filter_by: filterSearch.filter_by,
      page: pageNumber,
      per_page_items: itemsPerPage,
      sortList: JSON.stringify(sortList),
      ...selectedTab,
    });
  }

  getLoyaltyPointActivity(
    customerId: CustomerId,
    query?: Query
  ): Observable<PaginatedList<LoyaltyPointActivity[]>> {
    query = query || {};
    query.limit = query.limit || 10;
    const urlId = `${this.customerUrl}/${customerId}/loyalty-point-activities`;
    return this.cacheApi.getWithCache<LoyaltyPointActivity[]>(urlId, query).pipe(
      map((response: any) => {
        return {
          list: response.content.activities,
          pagination: response.content.pagination,
        };
      })
    );
  }

  addLoyaltyPoints(
    customerId: CustomerId,
    activity: AddLoyaltyPointActivity
  ): Observable<LoyaltyPointActivityListResponse> {
    const url = `${this.customerUrl}/${customerId}/loyalty-point-activities`;
    const payload = activity;

    return this.cacheApi.post<any, LoyaltyPointActivityListResponse>(url, payload).pipe(
      map((response: LoyaltyPointActivityListResponse) => {
        return response;
      })
    );
  }

  addClubPoints(form: any) {
    return this.dataService.post(this.apiEndPointAddLoyalty, form.value);
  }

  getCustomerLoyaltyProgram(query?: Query): Observable<PaginatedList<LoyaltyPrograms[]>> {
    const urlId = `${this.customerUrl}/loyalty-program`;
    return this.cacheApi.getWithCache<LoyaltyProgramListResponse>(urlId, query).pipe(
      map(({ content }: LoyaltyProgramListResponse) => ({
        list: content.loyalty_programs,
        pagination: content.pagination,
      }))
    );
  }

  getCustomerLoyaltyProgramDetail(loyaltyId: LoyaltyId): Observable<LoyaltyPrograms> {
    const urlId = `${this.customerUrl}/${loyaltyId}`;
    return this.cacheApi.getWithCache<LoyaltyProgramDetailResponse>(urlId).pipe(
      map((response: LoyaltyProgramDetailResponse) => {
        return response.content.loyalty_programs;
      })
    );
  }
}
